import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import {
  ClientRequestProtocolGetCrDetailsRequest,
  ClientRequestProtocolGetCrListCountRequest,
  ClientRequestProtocolGetCrListRequest,
} from '~/swagger/data-contracts';
import { queryClient } from '~/index';
import { customerRequestApi } from './index';

export const reportQueryKey = 'customer_request';

export const useHasNewRequestQuery = (enabled: boolean) => {
  return useQuery(
    [reportQueryKey, 'new_request'],
    async () => {
      const { data } = await customerRequestApi.getCr();
      return data;
    },
    {
      enabled,
    }
  );
};

export const useRequestListQuery = (request: ClientRequestProtocolGetCrListRequest) => {
  return useInfiniteQuery(
    [reportQueryKey, 'list', request],
    async ({ pageParam = 0 }) => {
      const { data } = await customerRequestApi.listCreate({ ...request, offset: pageParam });
      return data;
    },
    {
      getNextPageParam: (lastPage, allPage) => {
        if (lastPage.crList.length < request.limit) return;
        return request.limit * allPage.length;
      },
    }
  );
};

export const useRequestCountQuery = (request: ClientRequestProtocolGetCrListCountRequest) => {
  return useQuery([reportQueryKey, 'count', request], async () => {
    const { data } = await customerRequestApi.listCountCreate(request);
    return data;
  });
};

export const useRequestDetailQuery = (request: ClientRequestProtocolGetCrDetailsRequest) => {
  return useQuery([reportQueryKey, 'detail', request], async () => {
    const { data } = await customerRequestApi.detailsCreate(request);
    return data;
  });
};

export const useAddRequestMutation = () => {
  return useMutation(customerRequestApi.postCr, {
    onSuccess: () => {
      queryClient.invalidateQueries([reportQueryKey]);
    },
  });
};

export const useUploadRequestFileMutation = () => useMutation(customerRequestApi.uploadUrlCreate);
